import { render, staticRenderFns } from "./x-button-switch.vue?vue&type=template&id=3b27b2a2&scoped=true&"
import script from "./x-button-switch.vue?vue&type=script&lang=js&"
export * from "./x-button-switch.vue?vue&type=script&lang=js&"
import style0 from "./x-button-switch.vue?vue&type=style&index=0&id=3b27b2a2&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b27b2a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b27b2a2', component.options)
    } else {
      api.reload('3b27b2a2', component.options)
    }
    module.hot.accept("./x-button-switch.vue?vue&type=template&id=3b27b2a2&scoped=true&", function () {
      api.rerender('3b27b2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/molecules/x-button-switch.vue"
export default component.exports